<template>
  <el-table-column :prop="value" :width="width" v-if="show">
    <template slot="header">
      <div @click="handleSwitch">
        <span>{{ name }}</span>
        <span class="itemEye" v-if="ValueShow">
          <svg-icon
            :style="{ fontSize: calcFontSize(20, 20 * 0.3) }"
            icon-class="biyan"
            class="item-icon"
          ></svg-icon>
        </span>
        <span class="itemEye" v-else>
          <svg-icon
            :style="{ fontSize: calcFontSize(20, 20 * 0.3) }"
            icon-class="zhengyan"
            class="item-icon"
          ></svg-icon>
        </span>
      </div>
    </template>
    <template slot-scope="scope">
      <span v-if="ValueShow">
        <div v-if="value == 'lessee'">
          {{ scope.row[value] | lesseeFilter }}
        </div>
        <div v-if="value == 'userMobile'">
          {{ scope.row[value] | MobileFilter}}
        </div>
      </span>
      <span v-else style="margin-left: 10px">{{ scope.row[value] }}</span>
    </template>
  </el-table-column>
</template>
<script>
export default {
  props: {
    value: {
      default() {
        return "";
      },
    },
    name: {
      default() {
        return "";
      },
    },
    idName1: {
      default() {
        return "biyan";
      },
    },
    idName2: {
      default() {
        return "zhengyan";
      },
    },
    width: {
      type: Number,
      default: 110,
    },
  },
  filters: {
    lesseeFilter(lesseeValue) {
      if (lesseeValue) {
        let flag = "";
        for (let i = 0; i < lesseeValue.length - 1; i++) {
          flag = flag + "*";
        }
        return lesseeValue.substring(0, 1) + flag;
      }
      return lesseeValue;
    },
    MobileFilter(mobile) {
        if(mobile){
            mobile = mobile.substring(0, 3)+"****"+mobile.substr(mobile.length-4)
        }
        return mobile;
    },
  },
  data() {
    return {
      ValueShow: true,
      show: true,
    };
  },
  methods: {
    handleSwitch() {
      this.ValueShow = !this.ValueShow;
      // this.$forceUpdate()
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
      //   if(this.ValueShow){
      //     $("."+this.idName1).show();
      //     $("."+this.idName2).hide();
      //   }else{
      //     $("."+this.idName1).hide();
      //     $("."+this.idName2).show()
      //   }
    },
  },
};
</script>
<style scoped>
.itemEye {
  cursor: pointer;
}
/* .zhengyan{
  display: none;
} */
</style>


// WEBPACK FOOTER //
// src/components/ColumnlIistshow/index.vue